import type { TableToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useTableTokens = (theme: Theme): TableToken => {
  const { color, component } = theme;
  const base = {
    headBackgroundColor: color.background,
    headHoverBackgroundColor: color.neutralPressed,
    headTextColor: color.onSurfaceVariant,
    cellTextColor: color.onSurface,
  };

  return merge({}, base, component?.table) as TableToken;
};
